import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const fulInfo = JSON.parse(localStorage.getItem("myCat"));

export const fetchAllPagesAndExportToExcel =
    async ({
               apiUrl,
               filters = {},
               token = null,
               fileName = 'barcha_talabalar.xlsx',
               pageSize = 50,
               maxRetries = 1000, // fallback xavfsizlik uchun
    }) => {

    const allData = [];
    let page = 0;
    let totalPages = null;
    let retryCounter = 0;

    try {
        while (true) {
            const response = await axios.get(apiUrl, {
                headers: token ? { Authorization: `Bearer ${token}` } : {},
                params: {
                    ...filters,
                    page,
                    size: pageSize,
                },
            });

            const data = response?.data?.data;

            const content = data?.content || [];
            allData.push(...content);

            // totalPages birinchi response'dan olinadi
            if (totalPages === null) {
                totalPages = data?.totalPages ?? 0;

                // Agar server totalPages bermasa, loopdan chiqish uchun fallback
                if (!totalPages && content.length < pageSize) {
                    break;
                }
            }

            page++;

            // ✅ Cheksiz loopdan himoya
            retryCounter++;
            if (page >= totalPages || retryCounter >= maxRetries) {
                break;
            }
        }

        const mappedData = allData.map(item => {
            const row = {
                "F.I.SH": item.student?.fullName || "",
                "Talaba ID": item.student?.profile_id_number || "",
                "Kurs": item.student?.levelInfo?.name || "",
                "Guruh": item.student?.groupInfo?.name || "",
                "O‘quv yili": item.education_year_info?.name || "",
                "Fakultet": item.student?.departmentInfo?.name || "",
                "Yo‘nalish": item.student?.specialtyInfo?.name || "",
                "Hozirgi holati": item.student?.paymentFormInfo?.name || "",
                "Telefon": item.phone || "",
                // "Ijtimoiy faollik ball": item.departmentRating ?? "yo‘q",
                // "Akademik o‘zlashtirish ko‘rsatkichi": item.academicRating ?? "yo‘q",
                // "Umumiy ball": item.academicAndDepartmentRating ?? "yo‘q",
            };
            if (fulInfo.currentRole === "ROLE_ADMIN") {
                row["GPA"] = item.student?.avg_gpa ?? "yo‘q";
                row["Ijtimoiy faollik ball"] = item.departmentRating ?? "yo‘q"
                row["Akademik o‘zlashtirish ko‘rsatkichi"] = item.academicRating ?? "yo‘q"
                row["Umumiy ball"] = item.academicAndDepartmentRating ?? "yo‘q"
            }
            return row;
        });

        const worksheet = XLSX.utils.json_to_sheet(mappedData);
        worksheet['!cols'] = [
            { wch: 30 }, { wch: 10 }, { wch: 18 }, { wch: 12 },
            { wch: 35 }, { wch: 30 }, { wch: 20 }, { wch: 18 },
            { wch: 20 }, { wch: 6 }, { wch: 22 }, { wch: 15 }
        ];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Talabalar");

        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(blob, fileName);
    } catch (err) {
        console.error("Xatolik:", err);
        alert("Ma'lumotlarni yuklashda xatolik yuz berdi");
    }
};
